<template>
  <div class="date-input position-relative" :id="id">
    <datepicker @selected="dateSelected" :disabled="disabled || readonly" :disabled-dates="d_disabledDates" format="dd-MM-yyyy" :full-month-name="true" :monday-first="true" input-class="form-control" :placeholder="placeholder" :value="d_value" />

    <div class="calendar-icon d-flex align-items-center position-absolute right-0 top-0 bottom-0 pointer-events-none">
      <i class="fa fa-calendar-alt" />
    </div>
  </div>
</template>

<script>
import * as moment from 'moment';
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'form-date-input',
  components: { Datepicker },
  props: {
    disabled: Boolean,
    disabledFrom: String | Date,
    disabledTo: String | Date,
    id: String,
    placeholder: String,
    readonly: Boolean,
    value: String | Date,
  },
  data () {
    return {
      d_disabledDates: {
        from: new Date(this.disabledFrom),
        to: new Date(this.disabledTo),
      },
      d_value: '',
    };
  },
  created () {
    if (this.value) {
      this.d_value = moment(this.value).format('YYYY-MM-DD');
    }
  },
  methods: {
    dateSelected (date) {
      this.d_value = moment(date).format('YYYY-MM-DD');
    }
  },
  watch: {
    d_value () {
      this.$emit('input', this.d_value);
    },
    value (newValue, oldValue) {
      if (newValue && moment(oldValue).format('YYYY-MM-DD') === moment(newValue).format('YYYY-MM-DD')) {
        return;
      }

      this.d_value = this.value;
    },
    disabledFrom (value) {
      let newVal = new Date(value);

      if (newVal) {
        this.d_disabledDates.from = newVal;
      }
    },
    disabledTo (value) {
      let newVal = new Date(value);

      if (newVal) {
        this.d_disabledDates.to = newVal;
      }
    },
  },
};
</script>
